module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("Contents"), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/06prologue.htm"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/07intro.htm"
    }
  }, [_vm._v("Introduction")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch01.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 1"), _c('br'), _vm._v("\nLittle White Coffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch02.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 2"), _c('br'), _vm._v("\nBack to the Drawing Board")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch03.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 3"), _c('br'), _vm._v("\nThe Grand Experiment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch04.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 4"), _c('br'), _vm._v("\nHow Does It Feel to Be a Killer of Children?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch05.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 5"), _c('br'), _vm._v("\nA Man-Made Polio Epidemic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch06.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 6"), _c('br'), _vm._v("\nWhat Went Wrong at Cutter Laboratories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch07.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 7"), _c('br'), _vm._v("\nCutter in Court")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch08.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 8"), _c('br'), _vm._v("\nCigars, Parasites, and Human Toes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch09.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 9"), _c('br'), _vm._v("\nDeath for the Lambs")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/epilog.htm"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/notes.htm"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/bib.htm"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c5c41f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/05content.vue
// module id = 69
// module chunks = 0